import { CloudflareActionTypes } from './cloudflare.types';


const domainsRequest = ({ hostingId }) => ({
  type: CloudflareActionTypes.DOMAINS_REQUEST,
  payload: { hostingId },
});

const domainsFailure = payload => ({
  type: CloudflareActionTypes.DOMAINS_FAILURE,
  payload,
});

const domainsSuccess = payload => ({
  type: CloudflareActionTypes.DOMAINS_SUCCESS,
  payload,
});

const domainsSet = payload => ({
  type: CloudflareActionTypes.DOMAINS_SET,
  payload,
});

const domainsLoading = isLoading => ({
  type: CloudflareActionTypes.DOMAINS_LOADING,
  payload: isLoading,
});

const domainsError = bool => ({
  type: CloudflareActionTypes.DOMAINS_ERROR,
  payload: { bool },
});

const activeDomainsRequest = () => ({
  type: CloudflareActionTypes.ACTIVE_DOMAINS_REQUEST,
  payload: { },
});

const activeDomainsSuccess = () => ({
  type: CloudflareActionTypes.ACTIVE_DOMAINS_SUCCESS,
});

const activeDomainsFailure = () => ({
  type: CloudflareActionTypes.ACTIVE_DOMAINS_FAILURE,
});

const setActiveDomains = payload => ({
  type: CloudflareActionTypes.SET_ACTIVE_DOMAINS,
  payload,
});

const activeDomainsRequestLoading = payload => ({
  type: CloudflareActionTypes.ACTIVE_DOMAINS_REQUEST_LOADING,
  payload,
});

const activeDomainsResetStatus = () => ({
  type: CloudflareActionTypes.ACTIVE_DOMAINS_RESET_STATUS,
});

const activateCdn = ({
  hostingId, domain, domainOrigin, skipRequest, handleInternalDomainWithExternalProviderStatus,
}) => ({
  type: CloudflareActionTypes.ACTIVATE_CDN,
  payload: {
    hostingId,
    domain,
    domainOrigin,
    skipRequest,
    handleInternalDomainWithExternalProviderStatus,
  },
});

const deactivateCdn = ({
  hostingId, domain, domainOrigin, enqueueActivation, newHosting,
}) => ({
  type: CloudflareActionTypes.DEACTIVATE_CDN,
  payload: {
    hostingId,
    domain,
    domainOrigin,
    enqueueActivation,
    newHosting,
  },
});

const setLoadingActivation = bool => ({
  type: CloudflareActionTypes.LOADING_ACTIVATION,
  payload: bool,
});

const setActivatedDomain = domain => ({
  type: CloudflareActionTypes.SET_ACTIVATED_DOMAIN,
  payload: {
    domain,
  },
});

const succeededActivation = () => ({
  type: CloudflareActionTypes.LOADING_ACTIVATION_SUCCESS,
});

const faliedActivation = () => ({
  type: CloudflareActionTypes.LOADING_ACTIVATION_FAILURE,
});

const resetActivationStatus = () => ({
  type: CloudflareActionTypes.RESET_ACTIVATED_DOMAIN_STATUS,
});

const succeededDeactivation = () => ({
  type: CloudflareActionTypes.LOADING_DEACTIVATION_SUCCESS,
});

const faliedDeactivation = () => ({
  type: CloudflareActionTypes.LOADING_DEACTIVATION_FAILURE,
});

const statusOfFeaturesRequest = ({ cloudflareInternalId }) => ({
  type: CloudflareActionTypes.STATUS_OF_FEATURES_REQUEST,
  payload: { cloudflareInternalId },
});

const statusOfFeaturesSuccess = payload => ({
  type: CloudflareActionTypes.STATUS_OF_FEATURES_SUCCESS,
  payload,
});

const statusOfFeaturesFailure = payload => ({
  type: CloudflareActionTypes.STATUS_OF_FEATURES_FAILURE,
  payload,
});

const setStatusOfFeatures = payload => ({
  type: CloudflareActionTypes.SET_STATUS_OF_FEATURES,
  payload,
});

const statusOfFeaturesLoading = isLoading => ({
  type: CloudflareActionTypes.STATUS_OF_FEATURES_LOADING,
  payload: isLoading,
});

const statusOfFeaturesResetRequestStatus = () => ({
  type: CloudflareActionTypes.STATUS_OF_FEATURES_RESET_REQUEST_STATUS,
});

const requestUpdateFeature = ({
  cloudflareInternalId, feature, status,
}) => ({
  type: CloudflareActionTypes.UPDATE_FEATURE_REQUEST,
  payload: {
    cloudflareInternalId, feature, status,
  },
});

const successUpdateFeature = () => ({
  type: CloudflareActionTypes.UPDATE_FEATURE_SUCCESS,
});

const failureUpdateFeature = () => ({
  type: CloudflareActionTypes.UPDATE_FEATURE_FAILURE,
});

const loadingUpdateFeature = ({ isLoading, feature }) => ({
  type: CloudflareActionTypes.UPDATE_FEATURE_LOADING,
  payload: { isLoading, feature },
});

const setUpdateFeature = ({ data, feature, status }) => ({
  type: CloudflareActionTypes.SET_UPDATE_FEATURE,
  payload: { data, feature, status },
});

const resetUpdateFeatureStatus = () => ({
  type: CloudflareActionTypes.RESET_UPDATE_FEATURE_STATUS,
});

const purgeCacheRequest = ({ cloudflareInternalId }) => ({
  type: CloudflareActionTypes.REQUEST_PURGE_CACHE,
  payload: { cloudflareInternalId },
});

const purgeCacheSuccess = () => ({
  type: CloudflareActionTypes.REQUEST_PURGE_CACHE_SUCCESS,
});

const purgeCacheFailure = () => ({
  type: CloudflareActionTypes.REQUEST_PURGE_CACHE_FAILURE,
});

const purgeCacheLoading = isLoading => ({
  type: CloudflareActionTypes.REQUEST_PURGE_CACHE_LOADING,
  payload: isLoading,
});

const setPurgeCache = payload => ({
  type: CloudflareActionTypes.SET_PURGE_CACHE,
  payload,
});

const sitesWizardRequestDomainData = ({ domain, skipFinally = false }) => ({
  type: CloudflareActionTypes.SITES_WIZARD_REQUEST_DOMAIN_DATA,
  payload: { domain, skipFinally },
});

const requestSucceeded = () => ({
  type: CloudflareActionTypes.SITES_WIZARD_CLOUDFLARE_REQUEST_SUCCEEDED,
});

const requestFailed = () => ({
  type: CloudflareActionTypes.SITES_WIZARD_CLOUDFLARE_REQUEST_FAILED,
});

const setDomainsData = payload => ({
  type: CloudflareActionTypes.SITES_WIZARD_SET_DOMAIN_DATA,
  payload,
});

const speedAnalyticsRequest = ({ cloudflareInternalId, clearLastAnalysisId = false }) => ({
  type: CloudflareActionTypes.SPEED_ANALYTICS_REQUEST,
  payload: { cloudflareInternalId, clearLastAnalysisId },
});

const speedAnalyticsGetHistory = ({
  cloudflareInternalId,
  perPage,
  currentPage,
  enqueued,
  clearLastAnalysisId,
  updateLastAnalysis,
}) => ({
  type: CloudflareActionTypes.SPEED_ANALYTICS_GET_HISTORY,
  payload: {
    cloudflareInternalId,
    perPage,
    currentPage,
    enqueued,
    clearLastAnalysisId,
    updateLastAnalysis,
  },
});

const speedAnalyticsSetHistory = data => ({
  type: CloudflareActionTypes.SPEED_ANALYTICS_SET_HISTORY,
  payload: { data },
});

const setLastAnalysis = data => ({
  type: CloudflareActionTypes.SPEED_ANALYTICS_SET_LAST_ANALYSIS,
  payload: { data },
});

const speednAnalyticsSetLastAnalysisId = payload => ({
  type: CloudflareActionTypes.SPEED_ANALYTICS_SET_LAST_ANALYSIS_ID,
  payload,
});

const getAnalysisHistoryFailed = () => ({
  type: CloudflareActionTypes.SPEED_ANALYTICS_GET_HISTORY_FAILED,
});

const analyticsSucceededRequest = () => ({
  type: CloudflareActionTypes.ANALYTICS_SUCCEEDED_REQUEST,
});

const analyticsFailedRequest = () => ({
  type: CloudflareActionTypes.ANALYTICS_FAILED_REQUEST,
});

const analyticsResetRequestStatus = () => ({
  type: CloudflareActionTypes.RESET_HISTORY_REQUEST_STATUS,
});

const setLoadingAnalysis = ({ bool }) => ({
  type: CloudflareActionTypes.SET_LOADING_ANALYSIS,
  payload: { bool },
});

const setLoadingHistory = loading => ({
  type: CloudflareActionTypes.SPEED_LOADING_HISTORY,
  payload: loading,
});

const visitorsAnalysisRequest = ({ cloudflareInternalId, days }) => ({
  type: CloudflareActionTypes.VISITORS_ANALYSIS_REQUEST,
  payload: { cloudflareInternalId, days },
});

const setVisitorAnalysis = payload => ({
  type: CloudflareActionTypes.SET_VISITOR_ANALYSIS,
  payload,
});

const resetVisitorsAnalysis = () => ({ type: CloudflareActionTypes.RESET_VISITOR_ANALYSIS });

const setVisitorsSuccess = () => ({ type: CloudflareActionTypes.SET_VISITORS_SUCCESS });
const setVisitorsFailure = () => ({ type: CloudflareActionTypes.SET_VISITORS_FAILURE });

const addRuleRequest = ({ ruleData, cloudflareInternalId }) => ({
  type: CloudflareActionTypes.ADD_RULE_REQUEST,
  payload: { ruleData, cloudflareInternalId },
});

const addRuleSuccess = ({ newRule, blockedUntil = 0 }) => ({
  type: CloudflareActionTypes.ADD_RULE_SUCCESS,
  payload: { newRule, blockedUntil },
});

const addRuleFailure = ({ blockedUntil = 0 }) => ({
  type: CloudflareActionTypes.ADD_RULE_FAILURE,
  payload: { blockedUntil },
});

const setAddRuleLoading = payload => ({
  type: CloudflareActionTypes.SET_ADD_RULE_LOADING,
  payload,
});

const setSingleRuleLoading = ({ ruleId, isLoading }) => ({
  type: CloudflareActionTypes.SET_SINGLE_RULE_LOADING,
  payload: { ruleId, isLoading },
});

const resetAddRuleState = () => ({
  type: CloudflareActionTypes.RESET_ADD_RULE_STATE,
});

const resetDeleteRuleState = () => ({
  type: CloudflareActionTypes.RESET_DELETE_RULE_STATE,
});

const getRules = ({ cloudflareInternalId }) => ({
  type: CloudflareActionTypes.GET_RULES_REQUEST,
  payload: { cloudflareInternalId },
});

const setRulesLoading = isLoading => ({
  type: CloudflareActionTypes.SET_RULES_LOADING,
  payload: isLoading,
});

const setRules = payload => ({
  type: CloudflareActionTypes.SET_RULES,
  payload,
});

const getRulesSuccess = () => ({ type: CloudflareActionTypes.GET_RULES_SUCCESS });
const getRulesFailure = () => ({ type: CloudflareActionTypes.GET_RULES_FAILURE });

const resetGetRulesStatus = () => ({ type: CloudflareActionTypes.RESET_GET_RULES_STATUS });

const deleteRuleRequest = payload => ({ type: CloudflareActionTypes.DELETE_RULE_REQUEST, payload });
const deleteRuleSuccess = payload => ({ type: CloudflareActionTypes.DELETE_RULE_SUCCESS, payload });
const setDeleteRuleLoading = isLoading => ({ type: CloudflareActionTypes.DELETE_RULE_LOADING, payload: isLoading });

const editRuleRequest = payload => ({ type: CloudflareActionTypes.EDIT_RULE_REQUEST, payload });
const editRuleSet = ({ newList, success = false }) => ({
  type: CloudflareActionTypes.EDIT_RULE_SET,
  payload: { newList, success },
});
const setEditRuleLoading = isLoading => ({ type: CloudflareActionTypes.EDIT_RULE_LOADING, payload: isLoading });
const resetEditRuleState = () => ({ type: CloudflareActionTypes.RESET_EDIT_RULE_STATE });

const setRuleFormData = payload => ({ type: CloudflareActionTypes.SET_RULE_FORM_DATA, payload });

const toggleRuleStatus = payload => ({ type: CloudflareActionTypes.TOGGLE_RULE_STATUS_REQUEST, payload });
const toggleRuleStatusSet = ({ newList }) => ({
  type: CloudflareActionTypes.TOGGLE_RULE_STATUS_SET,
  payload: { newList },
});
const toggleRuleStatusFailure = payload => ({ type: CloudflareActionTypes.TOGGLE_RULE_STATUS_FAILURE, payload });

const actions = {
  sitesWizard: {
    request: sitesWizardRequestDomainData,
    setDomainsData,
    requestSucceeded,
    requestFailed,
  },
  domains: {
    domainsRequest,
    domainsFailure,
    domainsSuccess,
    domainsSet,
    domainsLoading,
    domainsError,
    active: {
      request: activeDomainsRequest,
      success: activeDomainsSuccess,
      failure: activeDomainsFailure,
      resetStatus: activeDomainsResetStatus,
      set: setActiveDomains,
      isLoading: activeDomainsRequestLoading,
    },
  },
  cdn: {
    activateCdn,
    deactivateCdn,
    setLoadingActivation,
    setActivatedDomain,
    succeededActivation,
    faliedActivation,
    succeededDeactivation,
    resetActivationStatus,
    faliedDeactivation,
  },
  features: {
    request: statusOfFeaturesRequest,
    success: statusOfFeaturesSuccess,
    failure: statusOfFeaturesFailure,
    resetRequestStatus: statusOfFeaturesResetRequestStatus,
    set: setStatusOfFeatures,
    loading: statusOfFeaturesLoading,
    update: {
      request: requestUpdateFeature,
      success: successUpdateFeature,
      failure: failureUpdateFeature,
      loading: loadingUpdateFeature,
      set: setUpdateFeature,
      resetStatus: resetUpdateFeatureStatus,
    },
  },
  purgeCache: {
    request: purgeCacheRequest,
    success: purgeCacheSuccess,
    failure: purgeCacheFailure,
    loading: purgeCacheLoading,
    set: setPurgeCache,
  },
  analysis: {
    requestSpeedAnalysis: speedAnalyticsRequest,
    getSpeedHistory: speedAnalyticsGetHistory,
    setSpeedHistory: speedAnalyticsSetHistory,
    getAnalysisHistoryFailed,
    setLastAnalysisId: speednAnalyticsSetLastAnalysisId,
    setLastAnalysis,
    success: analyticsSucceededRequest,
    failure: analyticsFailedRequest,
    statusReset: analyticsResetRequestStatus,
    setLoadingHistory,
    setLoadingAnalysis,

    requestVisitorsAnalysis: visitorsAnalysisRequest,
    setVisitorsSuccess,
    setVisitorsFailure,
    setVisitorAnalysis,
    resetVisitorsAnalysis,
  },

  security: {
    addRuleRequest,
    addRuleSuccess,
    addRuleFailure,
    setAddRuleLoading,
    resetAddRuleState,
    setSingleRuleLoading,

    getRules,
    setRulesLoading,
    setRules,
    getRulesSuccess,
    getRulesFailure,
    resetGetRulesStatus,

    deleteRuleRequest,
    deleteRuleSuccess,
    resetDeleteRuleState,
    setDeleteRuleLoading,

    editRuleRequest,
    editRuleSet,
    setEditRuleLoading,
    resetEditRuleState,

    setRuleFormData,

    toggleRuleStatus,
    toggleRuleStatusSet,
    toggleRuleStatusFailure,
  },
};

export default actions;
